import React, { useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GazeReport from "./GazeReport";
import {
  clearStoredGazeReportToken,
  parseGazeReportRequest,
  removeTokenFromSearch,
} from "./gazeReportQuery";
import { useT } from "../../../../i18n/useT";

// gazeReportQuery error codes → gazeReport i18n keys.
const INVALID_LINK_MESSAGE_KEYS = {
  duplicate_parameter: "invalid_duplicate",
  missing_parameter: "invalid_missing",
  invalid_parameter: "invalid_param",
};

const GazeMetricsReportRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const t = useT("gazeReport");
  const parsed = useMemo(
    () => parseGazeReportRequest(location.search),
    [location.search],
  );

  useEffect(() => {
    const previousTitle = document.title;
    document.title = t("page_title");
    return () => {
      document.title = previousTitle;
    };
  }, [t]);

  useEffect(() => {
    if (!parsed.ok || !parsed.tokenCameFromQuery) return;
    const sanitizedSearch = removeTokenFromSearch(location.search);
    window.history.replaceState(
      window.history.state,
      "",
      `${location.pathname}${sanitizedSearch}${location.hash}`,
    );
  }, [location.hash, location.pathname, location.search, parsed]);

  const handleUnauthorized = useCallback(() => {
    clearStoredGazeReportToken();
  }, []);

  const handleBack = useCallback(() => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
  }, [navigate]);

  if (!parsed.ok) {
    return (
      <main className="gaze-report-state" role="alert">
        <h1>{t("invalid_link")}</h1>
        <p>{t(INVALID_LINK_MESSAGE_KEYS[parsed.code] || "invalid_param")}</p>
      </main>
    );
  }

  return (
    <GazeReport
      request={parsed.request}
      onUnauthorized={handleUnauthorized}
      onBack={handleBack}
    />
  );
};

export default GazeMetricsReportRoute;
